// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__12CRh","left":"StickyBox_left__2HR2p","right":"StickyBox_right__gaFuo"};